var tabbedStandardTabsTitles = $(document).find('.tabbed-standard-tabs-left .tabbed-standard-tabs-titles');
if (tabbedStandardTabsTitles.length > 0) {

  $(window).on('load resize orientationchange', function () {
    if ($(window).width() > 768) {
      if (tabbedStandardTabsTitles.hasClass('slick-initialized')) {
        tabbedStandardTabsTitles.slick('unslick');
      }
      $(document).find('.tabbed-standard-tabs-titles > a').each(function() {
        $(this).on('click', function () {
          var tabContentID = $(this).children().attr('tabcontent');
          $(document).find('.tabbed-standard-tabs-title').removeClass('active');
          $(this).children().addClass('active');
          $(document).find(".tabbed-standard-tabs-content").removeClass('active');
          $(document).find('.tabbed-standard-tabs-content.' + tabContentID).addClass('active');
        });
      });
    }
    else {
      if (!tabbedStandardTabsTitles.hasClass('slick-initialized')) {
        tabbedStandardTabsTitles.slick({
          dots: false,
          infinite: true,
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          mobileFirst: true,
        });
      }
      $('.slick-slide.slick-current.slick-active').addClass('title-active');
      $(document).find('.tabbed-standard-tabs-title').on('click', function () {
        $(".tabbed-standard-tabs-title").parent().parent().parent().addClass('title-active');
        $(".tabbed-standard-tabs-title").not($(this)).parent().parent().parent().removeClass('title-active');
      });
    }
  });
}

var tabbedStandardCards = $(document).find('.tabbed-standard-tabs-content .tabbed-standard-tabs-content-cards');
if (tabbedStandardCards.length > 0) {

  $(window).on('load resize orientationchange', function () {
    tabbedStandardCards.each(function () {
      if ($(window).width() > 768) {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      }
      else {
        if ($(this).children().length >= 2 ) {
          if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
              dots: true,
              false: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              // centerMode: true,
              infinite: true,
            });
          }
          $(this).find('.tabbed-standard-tabs-content-card').each(function() {
            var setwidth = $('.tabbed-standard-tabs-contents').width();
            $(this).parent().css("width", setwidth+"px");
            $(this).css({
              "width": "inherit",
              "display": "block",
              "margin": "0 auto",
            });
          });
        }
      }
    });
  });
}
